import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import type { FileSearchRecord } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';
import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';
export const PathCell = t0 => {
  const $ = _c(4);
  const {
    entity
  } = t0;
  const {
    isAuthorized
  } = useRoles();
  let t1;
  if ($[0] !== entity.path || $[1] !== entity.resourceId || $[2] !== isAuthorized) {
    t1 = entity.path && <TextLink disabled={!isAuthorized("read:files")} href={`/explorer/${entity.resourceId}?file=${Base64.encode(entity.path)}`}><Typography sx={{
        color: "inherit"
      }}>{entity.path}</Typography></TextLink>;
    $[0] = entity.path;
    $[1] = entity.resourceId;
    $[2] = isAuthorized;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};